import React from 'react';
import {
  Navigate,
  RouteObject
} from 'react-router-dom';

import { ThemeLayout } from './ThemeLayout';
import { BasicThemeActivity } from './BasicThemeActivity/BasicThemeActivity';
import { ChartThemeActivity } from './ChartThemeActivity/ChartThemeActivity';
import { ChartTestActivity } from './ChartTestActivity/ChartTestActivity';



export const root: RouteObject = {
  path: 'theme',
  element: (<ThemeLayout />),
  children: [
    {
      path: '',
      element: <BasicThemeActivity />
    },
    {
      path: 'charts',
      element: <ChartThemeActivity />
    },
    {
      path: 'chartTest',
      element: <ChartTestActivity />
    }
  ]
};
